import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../components/auth/useAuth'
import { addParameter, getParameters,getParameter, editParameter, removeParameter } from '../../../actions/parametersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import ParameterForm from '../../../components/forms/ParameterForm'


export default function Parameters() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const {parameters, parameter, resultparameter, loading} = useSelector(state=>state.parameters)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getParameters())
        }
    },[dispatch, t, clientauth])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            name: '',
            minValue: 0,
            maxValue: 0
        })
        setModalShow(true)
    }

    const selectParameter = (parameter) => {
        dispatch(getParameter(parameter._id))
        setIsAddingOrEditing('editing')
        setFormState(parameter)
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSelectChange = (element)=>{
        setFormState({
            ...formState,
            [element.target.name]: element.target.value
        })
    }

    useEffect(()=>{
        if (parameter) {
            setFormState(parameter)
        }
    }, [parameter, dispatch])

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIsRegistering(true)
        if(isAddingOrEditing==='editing'){
            dispatch(editParameter(formState, formState._id))
        }else{
            dispatch(addParameter(formState))
        }
        setIsRegistering(false)
    }

    const handleDeleteParameters = async(e, parameterId) => {
        e.preventDefault()
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'warning',
            html: t('admin.parameters.areyousureremove')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeParameter(parameterId))
                setModalShow(false)
            }
        })
    }

    useEffect(() => {
        if(resultparameter){
            let resultparameterTemp = resultparameter
            dispatch({ type: 'PARAMETER_RESET_RESULT'})
            switch (resultparameterTemp) {
                case 'addsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.parameters.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'editsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.parameters.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                default:
                    break
            }
        }
    // eslint-disable-next-line
    }, [resultparameter])

    const columnsParameters = [
        {
            name: t('admin.parameters.name'),
            left: true,
            cell: parameter =>
                <div className='cursor' onClick={() => selectParameter(parameter)}>
                    {parameter.name}
                </div>,
            selector: (parameter) => `${parameter.name}`,
            sortable: true,
        },{
            name: t('admin.parameters.minValue'),
            width: '150px',
            right: true,
            cell: parameter =>
                <div className='cursor' onClick={() => selectParameter(parameter)}>
                    {parameter.minValue}
                </div>,
            selector: (parameter) => parameter.minValue,
            sortable: true,
        },{
            name: t('admin.parameters.maxValue'),
            width: '150px',
            right: true,
            cell: parameter =>
                <div className='cursor' onClick={() => selectParameter(parameter)}>
                    {parameter.maxValue}
                </div>,
            selector: (parameter) => parameter.maxValue,
            sortable: true,
        },{
            name: t('admin.parameters.tableunit'),
            width: '150px',
            right: true,
            cell: parameter =>
                <div className='cursor' onClick={() => selectParameter(parameter)}>
                    {t(`measures.${parameter.unitMeasure}`)}
                </div>,
            selector: (parameter) => parameter.unitMeasure,
            sortable: true,
        },{
            name: '',
            width: '80px',
            cell: parameter =>
                <div className='cursor' onClick={() => selectParameter(parameter)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col className='text-center'>
                    <h1>{t('admin.parameters.parameters')}</h1>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        {t('admin.parameters.createparameter')}
                    </Button>
                </Col>
            </Row>

            {
                loading
                    ?
                        <Loader/>
                    :
                        <Row>
                            <Col xs={12}>
                            {parameters?.length > 0
                                ?
                                    <CustomDataTable
                                        columns={columnsParameters}
                                        data={[...parameters].sort((a, b) => a.name.localeCompare(b.name))}
                                        exportable={true}
                                        printable={false}
                                        filter={true}
                                    />
                                :
                                    <h4 className='mt-4 text-center'>{t('admin.parameters.thereisnotparameters')}</h4>
                            }
                            </Col>
                        </Row>

            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.parameters.parameters')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ParameterForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        handleSelectChange={handleSelectChange}
                        handleDeleteParameters={handleDeleteParameters}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}